import { render, staticRenderFns } from "./ApprovalRequest.vue?vue&type=template&id=2c7a6e74&"
import script from "./ApprovalRequest.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports